export default __webpack_public_path__ + "3ecbaa2a34a8422e6b2222ff85fc9470.glb";